var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.628,
    height: 38.561,
    viewBox: "0 0 31.628 38.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#353841;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-46.022)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M56.508,147.635c-5.739-.033-10.486-11.748-10.486-17.715,0-9.746,7.311-11.88,10.129-11.88a11.655,11.655,0,0,1,3.822.94,8.542,8.542,0,0,0,2.182.626,6.791,6.791,0,0,0,1.565-.507,12.547,12.547,0,0,1,4.718-1.141h.011a9.671,9.671,0,0,1,8.093,4.087l.59.887-.849.641a7.148,7.148,0,0,0-3.428,5.895,6.653,6.653,0,0,0,3.712,6.151c.532.32,1.082.65,1.082,1.371,0,.471-3.76,10.587-9.22,10.587a7.414,7.414,0,0,1-3.113-.756,6.313,6.313,0,0,0-2.771-.667,7.128,7.128,0,0,0-2.194.594,10.748,10.748,0,0,1-3.806.888Z",
    transform: "translate(0 -109.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M262.4,0c.142,5.127-3.524,8.684-7.187,8.461C254.608,4.369,258.874,0,262.4,0Z",
    transform: "translate(-193.382)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.ec9ab6687487afc5f4a49921673523dc.svg";
export { ForwardRef as ReactComponent };